import React, {useEffect} from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { connect } from 'react-redux'

import { confirmAlert } from 'react-confirm-alert';
import { GenericTableButton } from "../../../components/buttons/buttonsActions";
import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    LIST, NO, NO_DATA_FOUND, YES
} from "../../../components/i18n/i18n";

import {remove, save, search} from "../../../redux/actions/xtorage/xtorageFileActions";
import {TT_DELETE, TT_EDIT, TT_NODE_ADD} from "../../../components/i18n/toolTips";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import XtorageFileForm from "./_form";

const XtorageFileList = props => {
    const fbDataBaseId = props.app?.fbDataBase?.id

    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    useEffect(()=>{
        if(!filter)
            props.setFilter( {
                fbDataBase : { id : fbDataBaseId },
                item : { code : null }
            });
    },[])

    useEffect(() => {
        refreshDataList(pageIndex, pageSize, filter);
    }, [pageIndex, pageSize]);

    const refreshDataList =  (_pageIndex, _pageSize, _filter) => props.search(_pageIndex, _pageSize, _filter)

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            props.remove(data.id)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const onNew = () => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <XtorageFileForm onClose={onClose} save={props.save}/>
                );
            }
        });
    };

    const actionsFormatter = (cell, row) => <>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => {
            props.setViewMode('FORM');
            props.setItem(row);
            props.setForm(true, false, false);
        }}/>
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>

    const confirmDeleteObject = () => {
        console.log('No implementado')
    }

    const confirmEditObject = () => {
        console.log('No implementado')
    }

    const confirmAddEditNode = () => {
        console.log('No implementado')
    }

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'registerDate',
            text: 'Fecha de registro',
            headerStyle: {width: '200px'},
        }, {
            dataField: 'name',
            text: 'Nombre',
            //headerStyle: {width: '200px'},
        }, {
            dataField: 'format',
            text: 'Formato'
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerStyle: {width: '230px'},
            formatter: actionsFormatter
        }
    ];

    return ( <Card>

        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={confirmDeleteObject}/>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={confirmEditObject}/>
                <GenericTableButton toolTip={TT_NODE_ADD} icon={'fa-plus'} permission={'edit'} onClick={onNew}/>
            </div>
        </CardTitle>

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || [] }
                columns={columns}
                noDataIndication={ NO_DATA_FOUND }
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card> )
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    search,
    save,
    remove,
})

export default connect(mapStateToProps, mapActionsToProps)(XtorageFileList)